import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}




// Додайте цю функцію
function updateSavingsBadge(variant) {
  const saveElement = document.querySelector('[data-product-save]');
  
  if (!saveElement) return;
  
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    const savings = variant.compare_at_price - variant.price;
    const savingsPercent = Math.round((savings * 100) / variant.compare_at_price);
    
    // Форматування грошей (використовуйте theme.moneyFormat з вашої теми)
    const formattedSavings = Shopify.formatMoney(savings, theme.moneyFormat);
    
    saveElement.querySelector('.money').textContent = formattedSavings;
    saveElement.querySelector('span:last-child').textContent = `(${savingsPercent}%)`;
    saveElement.style.display = 'block';
  } else {
    saveElement.style.display = 'none';
  }
}

// Додайте виклик цієї функції при зміні варіанта
// Знайдіть функцію, яка обробляє зміну варіанта і додайте:
updateSavingsBadge(variant);